import React from "react";
import ReactDOM from "react-dom/client";
import { PortalApp } from "./PortalApp.js";
import "../index.css";
import "./portal.css";

const root = document.getElementById("root");
if (!root) throw new Error("Root element #root not found");

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <PortalApp />
  </React.StrictMode>,
);
